import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useAuth } from '../AuthContext.tsx';
import { Icon } from '../components/FdPrimitives.tsx';

function prefersDark(): boolean {
  try {
    return window.localStorage.getItem('fdtheme') === 'dark';
  } catch {
    return false;
  }
}

export function LoginPage() {
  const [key, setKey] = useState('');
  const [error, setError] = useState('');
  const { login, token } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (token) navigate('/', { replace: true });
  }, [token, navigate]);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    try {
      await login(key);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Login failed');
    }
  };

  return (
    <div className={prefersDark() ? 'fd theme-dark login-canvas' : 'fd login-canvas'}>
      <form className="card login-card" onSubmit={submit}>
        <div className="cbd">
          <div className="login-brand">
            <img src={`${import.meta.env.BASE_URL}fd-logo-mark-light.png`} alt="FD" />
            <div>
              <div className="eyebrow">Internal access</div>
              <h1>FDID Console</h1>
            </div>
          </div>
          <div className="field">
            <label htmlFor="api-key">
              Tenant API key <span className="req">*</span>
            </label>
            <div className={error ? 'control error' : 'control'}>
              <Icon name="vpn_key" />
              <input
                id="api-key"
                type="password"
                value={key}
                onChange={(e) => setKey(e.target.value)}
                placeholder="fdsk_..."
                required
              />
            </div>
            {error && (
              <span className="help err" role="alert">
                <Icon name="error" />
                {error}
              </span>
            )}
          </div>
          <button className="btn prim login-submit" type="submit">
            <Icon name="login" />
            Sign in
          </button>
        </div>
      </form>
    </div>
  );
}
